<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="overlay"></div>
<div class="error-content flexbox">
  <span class="error-icon"></span>
  <div class="flex-1">
    <h3 class="font-strong mb-3 text-primary text-uppercase" i18n="@@maintenance">Maintenance</h3>

    <h5 class="font-strong mb-4" i18n="@@maintenanceBeBack">We'll be back in a few minutes.</h5>

    <p class="mb-4" i18n="@@maintenanceWait">
      Please wait for a few minutes. Sorry for the inconvenience but we're performing some maintenance at the moment.
    </p>
  </div>
</div>
